export const initEmptyBlockData = {
  title: "",
  subTitle: "",
  image: {
    src: "",
    alt: "",
  },
};
export const initBlockData = {
  ...initEmptyBlockData,
  title: "Lux Express operates in 7 countries",
  subTitle:
    "The latest information about specific departures can be found in trip search. Due to the travel restrictions in nearby countries, we are currently operating only in the Baltics."
};


